<template>
    <v-container>
        <v-row class="contentRow" justify="center" align="center">
            <v-col>
                <div style="border: 1px solid #1e7c83;" class="ma-5 pa-5">
                    <!-- Reduced SVG size and centered -->
					<div align="center">
						<v-icon color="success" style="font-size: 60px;" class="ma-5">fas fa-check-circle</v-icon>
					</div>
                    <div class="text-center">
                        <h2 class="ma-4">Your payment was successfully completed!</h2>
                        <p>Thank you for completing your secure online payment.</p>
                        <p>Have a great trail!</p>
						<v-btn class="ma-3" color="primary" to="/ProductPlan">Go Back</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import UpgradePackageAPI from "../../api/billing"

export default {
	name: "UpgradePlans",
	components: {
		
	},
	data() {
		return {
			sessionId: null,
			clientID: null,
			priceCategory: null,
			Email: null,
			CurrentPlan: null,
			PriceofPlan: null,
			SubmitTime: null,
			ExpireTime: null,
			SelectedPlan: null,
		}
	},
	created(){
		const query = this.$route.query
		this.sessionId = query.session_id
		this.clientID = query.clientID
		this.priceCategory = query.priceCategory
		this.Email = query.Email
		this.CurrentPlan = query.CurrentPlan
		this.PriceofPlan = query.PriceofPlan
		this.SubmitTime = query.SubmitTime
		this.ExpireTime = query.ExpireTime
		this.SelectedPlan = query.SelectedPlan
		this.getDataforPayment()
	},
	methods:{
		async getDataforPayment(){
			console.log(this.sessionId,this.clientID,this.priceCategory,this.Email,this.CurrentPlan,this.PriceofPlan,this.SubmitTime,this.ExpireTime,this.SelectedPlan)
			try{
				const response = await UpgradePackageAPI.getPaymentData(this.sessionId, this.clientID, this.priceCategory, this.Email, this.CurrentPlan, this.PriceofPlan, this.SubmitTime, this.ExpireTime, this.SelectedPlan)
				console.log(response)
			}catch (e) {
				console.log(e)
			}
		}
	}
}
</script>